import React, { useState, useEffect, useRef, useCallback } from "react";
import styles from "./Expertise.module.css";
import Icon from "../common/Icon";
import { Link } from "react-router-dom";
import roboticImg from "../../../../images/Robot-1.png";
import spmImg from "../../../../images/Controller-1.png";
import plasticImg from "../../../../images/HMI-1.png";
import glueImg from "../../../../images/mecha.png";

const EXPERTISE_SLIDES = [
  { index: "01", title: "Industrial Robots", text: "We design and build custom automated robotic material handling systems, glue dispensing systems, and more. As a preferred partner of Mitsubishi Electric, our team can design a solution specific to your application.", image: roboticImg },
  { index: "02", title: "Special Purpose Machines", text: "Purpose-built machines engineered around your exact process, letting you unlock high volume production while keeping investment and per-unit cost low.", image: spmImg },
  { index: "03", title: "Plastic Moulding", text: "End-to-end injection moulding services — from mould manufacturing and assembly to large scale production and continuous process refinement.", image: plasticImg },
  { index: "04", title: "Glue Dispensing Systems", text: "Precision dispensing systems integrated into your existing line for consistent, repeatable application at production speed.", image: glueImg },
];

export default function Expertise() {
  const [slide, setSlide] = useState(0);
  const slideCount = EXPERTISE_SLIDES.length;
  const touchStartX = useRef(null);

  const goSlide = useCallback((dir) => {
    setSlide((s) => (s + dir + slideCount) % slideCount);
  }, [slideCount]);

  useEffect(() => {
    const t = setInterval(() => goSlide(1), 6000);
    return () => clearInterval(t);
  }, [goSlide]);

  const onTouchStart = (e) => (touchStartX.current = e.touches[0].clientX);
  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (delta > 40) goSlide(-1);
    if (delta < -40) goSlide(1);
    touchStartX.current = null;
  };

  const current = EXPERTISE_SLIDES[slide];

  return (
    <section className={styles.expertise} id="about">
      <div className={styles.expertiseInner}>
        <button className={styles.expertiseArrow} onClick={() => goSlide(-1)} aria-label="Previous">
          <Icon.ChevronLeft />
        </button>

        <div className={styles.expertiseContent} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
          <div className={styles.expertiseText}>
            <span className={styles.eyebrow}>what we do</span>
            <h2 className={styles.expertiseHeading}>Our Expertise</h2>
            <div key={slide} className={styles.expertiseSlideText}>
              <p className={styles.expertiseIndex}>{current.index} / {current.title}</p>
              <p className={styles.expertiseBody}>{current.text}</p>
               <Link to="/product" className={styles.btnOutline}>Know more <Icon.ChevronRight /></Link>
            </div>
          </div>
          <div className={styles.expertiseArt} key={`art-${slide}`} aria-hidden="true">
            <img src={current.image} alt={current.title} className={styles.expertiseImg} />
          </div>
        </div>

        <button className={styles.expertiseArrow} onClick={() => goSlide(1)} aria-label="Next">
          <Icon.ChevronRight />
        </button>
      </div>

      <div className={styles.dots}>
        {EXPERTISE_SLIDES.map((s, i) => (
          <button
            key={s.index}
            className={`${styles.dot} ${i === slide ? styles.dotActive : ""}`}
            onClick={() => setSlide(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
